<template>
  <div>
    <div v-if="loading" style="height:calc(100vh)"></div>
    <div class="note-wrap" v-if="!loading">
      <div class="note">
        <div class="note-item">
          <div class="note-title-wrap">
            <div class="note-title">追加されているレポート</div>
            <div class="flex-space"></div>
            <div style="font-size:11px; color:#666" v-if="report_list.length > 0">{{ report_list.length }}件のレポート</div>
          </div>
          <div v-if="report_list.length == 0" class="note-nonote">レポートに追加されていません。</div>
          <div class="note-list-group" v-else>
            <div class="note-list-item title">
              <div class="note-list">タイトル</div>
              <div class="note-list-block">EGR</div>
              <div class="note-list-block">投稿数</div>
              <div class="note-list-block w-70px">リーチ数</div>
              <div class="note-list-block w-70px">いいね数</div>
              <div class="note-list-block w-70px">コメント数</div>
              <div class="note-list-block">保存数</div>
              <div class="note-list-block w-70px">コスト</div>
              <div class="note-list-block">CPF</div>
            </div>
            <div
              class="note-list-item"
              v-for="(report, report_index) in report_list"
              :key="report.report_id"
              :class="report_index + 1 == report_list.length ? 'noborder' : ''"
              v-show="report.report_name"
            >
              <div class="note-list" v-if="report.report_name">
                <div class="note-list-circle">
                  <font-awesome-icon :icon="['far', 'chart-bar']" style="color:#fff; font-size:8px" />
                </div>
                <el-tooltip :disabled="report.report_name.length < 13" placement="top-start">
                  <div slot="content">{{ report.report_name }}</div>
                  <div class="note-list-name pointer" @click="openReport(report.report_id)">{{ report.report_name }}</div>
                </el-tooltip>
              </div>
              <div class="info-value list">
                <div class="note-list-content">
                  <div class="note-list-block">{{ report.average_engagement_rate ? report.average_engagement_rate + "%" : '-' }}</div>
                  <div class="note-list-block">{{ report.post_num ? report.post_num + "件" : '-' }}</div>
                  <div class="note-list-block w-70px">{{ report.reach ? report.reach + "件" : '-' }}</div>
                  <div class="note-list-block w-70px">{{ report.like_count ? report.like_count + "件" : '-' }}</div>
                  <div class="note-list-block w-70px">{{ report.comments_count ? report.comments_count + "件" : '-' }}</div>
                  <div class="note-list-block">{{ report.save ? report.save + "件" : '-' }}</div>
                  <div class="note-list-block w-70px">{{ report.cost ? report.cost + "円" : "-" }}</div>
                  <div class="note-list-block">{{ report.cpf ? report.cpf + "円" : "-" }}</div>
                  <div class="note-list-block">
                    <img
                      :src="s3BaseUrl + '/postdata/' + report.shortcode + '_s.jpg'"
                      class="note-list-report-img"
                      @error="imgErrorPost(report_index, post_index)"
                      :id="'img-'+report_index"
                      v-if="report.shortcode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const root = process.env.VUE_APP_API;
const loadReportAPI = root + "/api/note/load_report";
export default {
  name: "note",
  props: ["id"],
  data() {
    return {
      report_list: [],
      mouseover: -1,
      comment_on: false,
      target: -1,
      loading: true,
      info_show: -1,
      note_show: -1,
      info_before: "",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission;
    },
  },
  mounted() {
    this.loadReport(true);
  },
  methods: {
    loadReport(loading) {
      if (loading == true) this.loading = true;
      this.axios
        .get(loadReportAPI, {
          params: {
            token: this.token,
            user_token: this.user_token,
            ig_id: this.id,
          },
        })
        .then((response) => {
          this.report_list = response.data.report_list;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openReport(report_id) {
      let routeData = this.$router.resolve({
        name: "reportDetail",
        params: {
          report_id: report_id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    imgErrorPost(report_index) {
      var img = document.getElementById("img-"+report_index);
      img.setAttribute("src", this.s3BaseUrl + "/postdata/img_error_post_s.jpg");
    },
  },
  watch: {
    id() {
      this.notes = [];
      this.notes_info = [];
      this.loadReport();
    },
  },
};
</script>
